import type { Dish, DishInput } from '@lemontaigu/shared';
import { getMenuStore } from './store.js';

// Pure row<->domain transforms now live in ./transform.js; re-exported here so
// existing importers keep resolving them from './dishes.js'.
export { inputToRow, rowToDish } from './transform.js';
export type { DishRow } from './transform.js';

export function listDishes(): Promise<Dish[]> {
  return getMenuStore().listDishes();
}

export function createDish(input: DishInput): Promise<Dish> {
  return getMenuStore().createDish(input);
}

export function updateDish(id: number, patch: Partial<DishInput>): Promise<Dish> {
  return getMenuStore().updateDish(id, patch);
}

/** Soft delete (recoverable trash) — sets deleted_at; reads filter it out. */
export function softDeleteDish(id: number): Promise<void> {
  return getMenuStore().softDeleteDish(id);
}

export function bulkSetActive(ids: number[], active: boolean): Promise<Dish[]> {
  return getMenuStore().bulkSetActive(ids, active);
}
